import React from 'react';
import close from "../../../../images/close.svg";
import {useTranslation} from "react-i18next";
import {NavLink, Redirect} from "react-router-dom";
import {connect} from "react-redux";
import {deleteProfile} from "../../../../redux/user/user-thunks";
import {setIsDeletedProfile} from "../../../../redux/user/user-actions";

const ProfileDelete = ({isDark, deleteProfile, isDeletedProfile, setIsDeletedProfile}) => {
  const {t} = useTranslation()
  if(isDeletedProfile) {
    setIsDeletedProfile(false)
    return <Redirect to={'/auth'} />
  }
  return (
    <div>
      <div className="overlay"></div>
      <div style={{width: 481}} className={`modal small-modal ${isDark && 'modal__dark'}`}>
        <h5 className="modal__title">{t('requestToDelete')}</h5>
        <NavLink to={'licenses'}  className="modal__close small-modal__close">
          <img src={close} alt=""/>
        </NavLink>
        <p className="modal__text">{t('areYouSure')}</p>
        <div className="modal__actions mt-40">
          <button onClick={deleteProfile} className="delete-button mr-24">
            {t('acceptDelete')}
          </button>
          <NavLink to={'licenses'} className={`commonBtn ${isDark && 'commonBtn__dark'}`}>
            <span className="commonBtn__label">{t('cancelDelete')}</span>
          </NavLink>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  isDeletedProfile: state.userReducer.isDeletedProfile
})

export default connect(mapStateToProps, {deleteProfile, setIsDeletedProfile})(ProfileDelete)
